import {
  differenceInMilliseconds,
  differenceInYears,
  isValid,
  parse,
} from 'date-fns';

import { DateTime } from '../../graphql/DateTime';

export const calculateAge = (dob: string): number | null => {
  if (!dob) {
    return null;
  }

  try {
    const date = parse(
      dob,
      'yyyy-MM-dd',
      DateTime.getCurrentDateTimeWithCentralOffset()
    );
    if (!isValid(date)) {
      return null;
    }
    return differenceInYears(
      DateTime.getCurrentDateTimeWithCentralOffset(),
      date
    );
  } catch {
    return null;
  }
};

/**
 *  Helper to find where a given date range is compared to the current date.
 *  Returns: -1 if entire date range is in the past.
 *            0 if current date is between start and end dates.
 *            1 if entire date range is in the future.
 *            'undefined' otherwise (invalid date strings, start date after end date, etc)
 */
export const compareDateRangeToDate = (
  startDateString: string,
  endDateString: string
): number | undefined => {
  const startDate = new Date(startDateString);
  const endDate = endDateString
    ? new Date(endDateString)
    : new Date('9999-12-31');

  // Set endDate timestamp to end of day
  endDate.setUTCHours(23, 59, 59, 999);

  const curDate = DateTime.getCurrentDateTimeWithCentralOffset();

  switch (true) {
    case startDate > endDate:
      return undefined;
    case curDate > startDate && curDate > endDate:
      return -1;
    case curDate < startDate && curDate < endDate:
      return 1;
    case curDate >= startDate && curDate <= endDate:
      return 0;
    default:
      return undefined;
  }
};

export const compareCoverageEffectiveDate = (startDateString: string) => {
  const startDate = new Date(startDateString);
  const curDate = DateTime.getCurrentDateTimeWithCentralOffset();

  return curDate <= startDate;
};

export function randomDateWithin60Days() {
  const date = DateTime.getCurrentDateTimeWithCentralOffset();
  const daysToAdd = Math.floor(Math.random() * 60) + 1; // random number between 1 and 60
  date.setDate(date.getDate() + daysToAdd);
  return date.toISOString().split('T')[0];
}

export const getTodayDateInMMDDYYYY = (): string => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const year = now.getFullYear();
  const today = month + '/' + day + '/' + year;

  return today;
};

export const calculateTimeDuration = (dateValue: string): number | null => {
  if (!dateValue) {
    return null;
  }

  try {
    const date = parse(
      dateValue,
      'yyyy-MM-dd',
      DateTime.getCurrentDateTimeWithCentralOffset()
    );
    if (!isValid(date)) {
      return null;
    }
    return differenceInMilliseconds(
      DateTime.getCurrentDateTimeWithCentralOffset(),
      date
    );
  } catch {
    return null;
  }
};

export const convertDaytoMilliseconds = (numberOfDays: string): number => {
  const days = parseInt(numberOfDays, 10);
  return days * 24 * 60 * 60 * 1000;
};
